import { Fragment } from 'react';

import { Text } from '../../FormControls/Text';
import { Input } from '../../FormControls/Input';
import { Stack } from '../../FormControls/Stack';
import { Dropdown } from '../../FormControls/Dropdown';
import industries from '../../../assets/industries.json';

import { ScreenControl } from '../ScreenControl';

import { setName, setPointsOfSale, setType } from '../../../../main/slices/bussinessSlice';
import { useDispatch, useSelector } from 'react-redux';

export const Bussines = ({ dimensions }) => {

    const state = useSelector(({ bussines }) => bussines);
    const dispatch = useDispatch();

    // UPDATES THE STATE ON INPUT CHANGE
    const handleChange = (key, value) => {
        if (key === "name") dispatch(setName({ value, error: !value }));
        else if (key === "pointsOfSale") dispatch(setPointsOfSale({ value, error: !value }));
        else if (key === "type") dispatch(setType({ value, error: !value }));
    }

    return (
        <Fragment>
            <Stack
                flex={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}
                sx={{ ...dimensions }}
            >

                <Text classes={["subtitle"]}> Cuéntanos un poco de tu negocio </Text>
                <Text classes={["title"]}> Detalles de tu negocio </Text>

                <Input //BUSSINES NAME INPUT
                    type="text"
                    classes={["marginTB1em"]}
                    placeHolder="Nombre del negocio"
                    attributes={{ value: state.name.value }}
                    onChange={({ target }) => handleChange("name", target.value)}
                />

                <Input //BUSSINES POINTS OF SALE INPUT
                    type="number"
                    classes={["marginTB1em"]}
                    placeHolder="Numero de puntos de venta"
                    attributes={{ value: "1" || state.pointsOfSale.value, disabled: true }}
                    onChange={({ target }) => handleChange("pointsOfSale", target.value)}
                />

                <Dropdown
                    classes={["marginT1em"]}
                    options={industries}
                    onSelect={({ val }) => handleChange("type", val)}
                />

            </Stack>

            <ScreenControl disabled={(state.name.error || state.type.error)}></ScreenControl>
        </Fragment>
    );
}